export default "__VITE_ASSET__ChrmDAzQ__"